import React, { useEffect } from "react";

// components
import {
    Button,
    Input,
    Modal,
} from "reactstrap";
import MaterialTable from "material-table";


// services
import { showMessage } from "../../../services/message.js";
import { getSessionCookie } from "../../../services/session.js";
import { api_POST } from "../../../services/api_service.js";

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

export default function ModalOrdensColetaSequencia({ stateModalOrdensColetaSequencia, ordensColeta, handleReturn, showLoading }) {
    const session = getSessionCookie();


    const [stateModal, setstateModal] = React.useState(stateModalOrdensColetaSequencia);

    const [list, set_list] = React.useState([]);

    useEffect(() => {
        setstateModal(stateModalOrdensColetaSequencia);
    }, [stateModalOrdensColetaSequencia]);

    useEffect(() => {
        set_list(ordensColeta);
    }, [ordensColeta]);

    const Return = () => {
        handleReturn(null);
    }

    const handleConfirmarOrdenacao = () => {
        let ordens = [];
        list.filter(f => f.ordemColetaId != 0).map(m => {
            ordens.push({
                ordemColetaId: m.ordemColetaId,
                ordemExecucao: m.ordemExecucao
            })
        })
        let json_post = {
            ordensColeta: ordens,
            usuarioId: session.usuarioId
        }

        showLoading(true);
        api_POST(`ordemcoleta/PostOrdenacaoExecucao`, json_post).then(result => {
            showLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Configuração realizada com sucesso. Continue o cadastro da ordem de Serviço!", 'success', function () {
                    handleReturn(list)
                });
            }
        });
    }

    const handleSequenciaChange = (value, rowData) => {
        let new_list = [];
        list.map(m => {
            if (m.ordemColetaId == rowData.ordemColetaId)
                m.ordemExecucao = value == "" ? 1 : value;
            new_list.push(m);
        });

        set_list(new_list);
    }

    const columnsProp = [
        { title: 'Setor', field: "setorColeta.descricao" },
        { title: 'Status', field: "statusExecucaoOrdemColeta" },
        { title: 'Recurso', field: "veiculo.placa" },
        {
            title: 'Sequência', field: "ordemExecucao",
            render: (rowData) =>
                rowData && (
                    <Input type="number" onBlur={(e) => handleSequenciaChange(e.target.value, rowData)} defaultValue={rowData.ordemExecucao} />
                )
        }
    ]

    return (
        <>
            <Modal
                className="modal-dialog-centered"
                isOpen={stateModal}
                size="lg"
            >
                <div className="modal-header">
                    <h4 className="modal-title" id="modal-title-default">
                        Sequencia de Execução das Ordens de Serviço
                    </h4>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => handleReturn()}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div>
                        <MaterialTable
                            title="Lista de Ordens de Serviço"
                            columns={columnsProp}
                            data={list}
                            options={{ ...table_style, isFreeAction: true, headerStyle: { zIndex: 0 } }}
                            localization={table_translate}
                        />
                    </div>
                </div>
                <div className="modal-footer">
                    <Button color="secondary" type="button" onClick={Return}>
                        Fechar
                    </Button>
                    <Button color="success" type="button" onClick={handleConfirmarOrdenacao}>
                        Confirmar
                    </Button>
                </div>
            </Modal>
        </>
    );
}
